import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { Typography, FormControlLabel } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 25px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export const ImportantNotice = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  margin-bottom: 10px;
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 40px;
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 25px;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StatusContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StatusContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwitchContainer = styled.div<{ isActive: boolean }>`
  padding: 8px;
  border: 1px solid
    ${({ isActive, theme }) =>
      isActive ? theme.palette.success.main : theme.palette.error.main};
  border-radius: 999px;
  width: fit-content;

  .MuiFormControlLabel-root {
    margin: 0;
    gap: 6px;
    .MuiFormControlLabel-label {
      font-weight: 500;
      color: ${({ isActive, theme }) =>
        isActive ? theme.palette.success.dark : theme.palette.error.dark};
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const InfoIconStyled = muiStyled(InfoOutlined)(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.primary,
}));

export const InfoTypography = muiStyled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
}));

export const ImportantLabel = muiStyled("span")({
  fontWeight: 500,
});

export const StatusTypography = muiStyled(Typography)({
  fontWeight: 500,
});

export const StatusCaptionTypography = muiStyled(Typography)({
  color: "#666",
  display: "block",
});

export const FormControlLabelStyled = muiStyled(FormControlLabel)({
  margin: 0,
});

export const FullWidthInputWrapper = styled.div`
  grid-column: 1 / -1;
`;
